import { Header } from "../../../../src/components/common/header";
import { ForgotPassword } from "../../../../src/components/forgot-password";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  Header,
  ForgotPassword,
  Footer,
  React
};